import { render, staticRenderFns } from "./renewal-status-report.vue?vue&type=template&id=167bc8cc&scoped=true"
import script from "./renewal-status-report.vue?vue&type=script&lang=js"
export * from "./renewal-status-report.vue?vue&type=script&lang=js"
import style0 from "./renewal-status-report.vue?vue&type=style&index=0&id=167bc8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167bc8cc",
  null
  
)

export default component.exports